<template lang="pug">
section.totalizadores
    h3 {{ $t('mensagens.home.totalizadores.titulo') }}

    .totalizadores__linha
        .lyra__cartao(v-loading='carregando')
            .informacoes
                .totalizadores__header
                    h1.totalizadores__titulo
                        | {{ formatters.formatNumberUs(totalizadores.territoriosCadastrados, 3) }}
                    .icone
                        i.lyra-icon.lyra-territorio
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.territoriosCadastrados') }}

        .lyra__cartao(v-loading='carregando')
            .informacoes
                .totalizadores__header
                    h1.totalizadores__titulo
                        | {{ formatters.formatNumberUs(totalizadores.territoriosMonitorados, 3) }}
                    .icone
                        i.lyra-icon.lyra-territorio-monitorado
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.territoriosMonitorados') }}

        .lyra__cartao(v-loading='carregando')
            .informacoes
                .totalizadores__header
                    h1.totalizadores__titulo
                        | {{ totalizadores.areasFormatada }}
                    .icone
                        i.lyra-icon.lyra-hectare-monitorado
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.hectaresEmMonitoramento') }}

    .totalizadores__linha
        .lyra__cartao(v-loading='carregando')
            .informacoes
                .totalizadores__header
                    h1.totalizadores__titulo
                        | {{ formatters.formatNumberUs(totalizadores.proprietarios, 3) }}
                    .icone
                        i.lyra-icon.lyra-user
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.pessoasCadastradas') }}

        .lyra__cartao(v-loading='carregando')
            .informacoes
                .totalizadores__header
                    h1.totalizadores__titulo
                        | {{ formatters.formatNumberUs(totalizadores.diagnosticos, 3) }}
                    .icone
                        i.lyra-icon.lyra-diagnostico-socio
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.diagnosticosSocioambientais') }}

        .lyra__cartao(v-loading='carregando')
            .informacoes
                .totalizadores__header
                    h1.totalizadores__titulo
                        | {{ formatters.formatNumberUs(totalizadores.laudos, 3) }}
                    .icone
                        i.lyra-icon.lyra-laudos
                h2.totalizadores__subtitulo {{ $t('mensagens.home.totalizadores.laudosEmitidos') }}
</template>

<script>
import UtilsService from '@/services/UtilsService';
import formatters from '@/utils/formatters';
import { mapState } from 'vuex';

export default {
    name: 'Totalizadores',

    data() {
        return {
            formatters,
            totalizadores: {},
            carregando: true
        };
    },

    computed: {
        ...mapState(['usuarioIsLaudo', 'usuarioLogado'])
    },

    watch: {
        usuarioLogado: {
            handler() {
                this.buscarTotalizadores();
            },
            deep: true
        }
    },

    methods: {
        async buscarTotalizadores() {
            this.carregando = true;
            try {
                const { data } = await UtilsService.buscarTotalizadores();

                if (this.usuarioIsLaudo) {
                    this.totalizadores = this.zerarPropriedades(data);
                } else {
                    this.totalizadores = data;
                }
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.home.totalizadores.erro')
                });
            } finally {
                this.carregando = false;
            }
        },
        zerarPropriedades(obj) {
            const newObj = { ...obj };

            Object.keys(newObj).forEach(key => {
                if (key !== 'laudos' && key !== 'laudosFormatado') {
                    if (typeof newObj[key] === 'number') {
                        newObj[key] = 0;
                    } else if (typeof newObj[key] === 'string') {
                        newObj[key] = key.includes('Formatado') ? '0' : '';
                    } else if (typeof newObj[key] === 'object' && newObj[key] !== null) {
                        newObj[key] = this.zerarPropriedades(newObj[key]);
                    }
                }
            });

            return newObj;
        }
    },

    async mounted() {
        await this.buscarTotalizadores();
    }
};
</script>

<style lang="scss" scoped>
.totalizadores {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    h3 {
        font-weight: 700;
        margin-bottom: 5px;
    }

    .totalizadores__linha {
        flex-grow: 1;
        display: grid;
        grid-template-columns: repeat(3, minmax(250px, 1fr));
        gap: 8px;
        margin-bottom: 8px;
    }

    .totalizadores__linha:last-child {
        margin-bottom: 0;
    }

    .lyra__cartao {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-height: 0;
        flex: 1;
        max-width: 300px;
        justify-content: space-between;

        .informacoes {
            display: flex;
            width: 100%;
            margin-top: 2rem;
            flex-direction: column;
            justify-content: space-between;
        }

        .totalizadores__header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }

        .icone {
            display: flex;
            align-self: flex-start;
            margin-left: auto;
            margin-right: 2rem;

            .lyra-icon {
                display: flex;
            }

            .lyra-icon::before {
                content: '';
                width: 32px !important;
                height: 33.5px !important;
                background-color: var(--primary) !important;
                opacity: 0.7;
            }
            .lyra-territorio::before, .lyra-territorio-monitorado::before, .lyra-hectare-monitorado::before,
            .lyra-diagnostico-socio::before, .lyra-laudos::before {
                width: 35px !important;
                height: 35.5px !important;
            }
        }
    }

    .totalizadores__titulo {
        font-size: 35px;
        margin: 0 0 0.5rem 2rem;
        text-align: left;
        color: var(--primary);
    }

    .totalizadores__subtitulo {
        font-size: 16px;
        width: max-content;
        align-items: flex-start;
        margin: 2rem 0 0 2rem;

        font-weight: 400;
        text-align: left;

        color: var(--primary);
    }

    @media (max-width: 800px) {
        .totalizadores__linha {
            gap: 4px;
        }
        .lyra__cartao{
            justify-content: center;
        }
        .totalizadores__subtitulo {
            margin-bottom: 1rem;
        }

        .lyra__cartao {
            max-width: 100%;
        }

        .lyra__cartao .informacoes {
            margin-top: 1rem;
        }
    }

    @media (min-width: 1440px) {
        .totalizadores__linha {
            gap: 6px;
            grid-template-columns: repeat(3, minmax(100px, 1fr));

        }
        .lyra__cartao{
            max-height: 300px;
            justify-content: center;
            max-width: inherit;
            .icone {
                margin-right: 10%;
            }
        }
        .totalizadores__subtitulo {
            margin-bottom: 2rem;
        }
    }
    @media (min-height: 1200px) {
        height: 50%;
        .totalizadores__linha {
            width: 100%;
            height: 100%;
            grid-template-columns: repeat(3, minmax(100px, 0.5fr));
        }
        .lyra__cartao {
            max-width: 450px;
            width: 100%;
            height: 100%;
        }
    }
}
</style>
